import { Outlet, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";

import { useMaterialUIController, setAuth, setPersist } from "context";

//import useAuth from "hooks/useAuth";
export default function PersistLogin({ children }) {
  const [isLoading, setIsLoading] = useState(true);
  const [controller, dispatch] = useMaterialUIController();

  const navigate = useNavigate();
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (token) {
      axios
        .post("https://api.dahiyainsurance.com/verify-token.php", { Token: token })
        .then((response) => {
          const result = response.data;
          if (result.status === 1) {
            const user = result.Data;
            const permissions = result.Permissions;
            localStorage.setItem("persist", "true");
            localStorage.setItem("access", result.Data.SessionID);
            setAuth(dispatch, {
              user,
              roles: [5150, 1984, 2001],
              permissions,
              accessToken: result.Data.SessionID,
            });
            setPersist(dispatch, true);
            navigate("/dashboard", { replace: true });
            // ✅ remove token from URL
            //window.history.replaceState({}, document.title, "/dashboard");
          }
        })
        .finally(() => setIsLoading(false));
    } else {
      setIsLoading(false);
    }
  }, [navigate]);

  if (isLoading) return <p>Checking login...</p>;

  return children; // ✅ render routes after check
}
